import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { loader } from "../../redux/type";
import OtpInput from "react-otp-input";
import { updateCitizenProfile } from "../../Services/getServices";

const OnlineMeasurementEMB = () => {



  const dispatch = useDispatch();
  
  const userData = JSON.parse(localStorage.getItem("user"));
  const urL = useLocation().state?.url_Link;

  const token = localStorage.getItem("token");
  const url2 = `${urL}?token=${token}`;
  console.log("URL=", url2);

  const domainCode = useLocation().state?.doCode;
  const id = userData?.user?.id;

    function saveUser() {
      let req = {
        userId: id,
        domainCode: domainCode,
        // consumerId: consumerId,
      };
      dispatch({ type: loader.startLoader });
      updateCitizenProfile(req, (res) => {
        dispatch({ type: loader.stopLoader });
        if (res?.data?.status) {
          toast.success(res?.data?.message);
        } else {
          toast.error(res?.data?.message);
        }
      });
    }
  

  return (
    <>
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">

        <h4 className="h2_heading">EMB</h4>
          <div className="row  ">
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Email:
                </label>
                <input
                  type="mobile"
                  //   onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>


            <div className="col-4 " style={{ marginTop: "2rem" }}>
                  <a href={url2} target="_blank" alt="Link Not working">
                    <button className="btn btn-primary" onClick={saveUser}>
                      Clik here to open
                    </button>
                  </a>
                </div>


          </div>
        </div>
      </div>
    </>
  );
};
export default OnlineMeasurementEMB;
